import { PriceEntityCosmos } from "../app/store/product/productOverview/types";
import Accessories from "../constants/Accessories";
import { IProduct } from "../entities/product/types";
import Validator from "../validators/Validator";
import TariffPackageService from "./TariffPackageService";
import UrlService from "./UrlService";

export default class PriceService {

  static urlParams: any;

  static init() {
    this.urlParams = UrlService.getParamsFromUrlOnLoadPage();
  }

  static getCosmosPriceItem(product: IProduct) {
    this.init();
    if (Accessories.includes(product.productLine?.productLine)) {
      const prices = product.productPrices.cosmos;
      return Validator.isUndefined(this.getCosmosPriceByInstallments(prices)) ?
        this.getCosmosPriceBySelectedItem(prices) :
        this.getCosmosPriceByInstallments(prices);
    }

    const tariffPackage = TariffPackageService.getTpByTpId(product, Number(this.urlParams.tariff), UrlService.getPurchase());
    return Validator.isUndefined(this.getCosmosPriceByInstallments(tariffPackage?.prices?.cosmos)) ?
      this.getCosmosPriceBySelectedItem(tariffPackage?.prices?.cosmos) :
      this.getCosmosPriceByInstallments(tariffPackage?.prices?.cosmos);
  }

  static getCosmosPriceByInstallments(prices: PriceEntityCosmos[]) {
    this.init();
    return prices?.find((item: any) => item.installments === Number(this.urlParams.cosmosInstallments));
  }

  static getCosmosPriceBySelectedItem(prices: PriceEntityCosmos[]) {
    return prices?.find((item: any) => item.selected);
  }

  static calculateParticipationValue(value: number, product: IProduct) {
    return value - (value % (this.getCosmosPriceItem(product)?.cosmosParticipation?.step ?? 1));
  }

}
